/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LongRangeModel model module.
 * @module model/LongRangeModel
 * @version v1.0.0
 */
class LongRangeModel {
    /**
     * Constructs a new <code>LongRangeModel</code>.
     * @alias module:model/LongRangeModel
     */
    constructor() { 
        
        LongRangeModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LongRangeModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LongRangeModel} obj Optional instance to populate.
     * @return {module:model/LongRangeModel} The populated <code>LongRangeModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LongRangeModel();

            if (data.hasOwnProperty('max')) {
                obj['max'] = ApiClient.convertToType(data['max'], 'Number');
            }
            if (data.hasOwnProperty('min')) {
                obj['min'] = ApiClient.convertToType(data['min'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} max
 */
LongRangeModel.prototype['max'] = undefined;

/**
 * @member {Number} min
 */
LongRangeModel.prototype['min'] = undefined;






export default LongRangeModel;

